// extracted by mini-css-extract-plugin
export default {"inventory":"InventoryList_inventory__qPczE","inventoryEntry":"InventoryList_inventoryEntry__afcAn"};